import React from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { ActionButton } from "@/components/ActionButton";
import { OfferCardNote } from "./types";
import { AppText } from "@/components/AppText";
import { FontFamilies } from "@/constants/Typography";

interface OfferCardActionsProps {
  onHide?: () => void;
  actionTitle?: string;
  actionIcon?: React.ReactNode;
  onActionPress?: () => void;
  notes?: OfferCardNote[];
}

export function OfferCardActions({
  onHide,
  actionTitle,
  actionIcon,
  onActionPress,
  notes,
}: OfferCardActionsProps) {
  return (
    <View style={styles.actions}>
      {!Array.isArray(notes) || notes.length === 0 ? (
        <View />
      ) : (
        notes.map((note) => {
          return (
            <View key={note.text} style={styles.noteContainer}>
              {note.icon}
              <AppText
                style={styles.noteText}
                numberOfLines={2}
              >
                {note.text}
              </AppText>
            </View>
          );
        })
      )}
      {actionTitle && onActionPress && (
        <ActionButton
          title={actionTitle}
          type="primary"
          onPress={onActionPress}
          style={styles.claimButton}
          icon={actionIcon}
          iconPosition="right"
          textStyle={styles.claimButtonText}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  actions: {
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 12,
    justifyContent: "space-between",
    overflow: "hidden",
  },
  noteContainer: {
    flexShrink: 1,
    flexDirection: "row",
    gap: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  noteText: {
    fontFamily: FontFamilies.InterTight.Regular,
    fontSize: 13,
    color: "#000000",
  },
  claimButton: {
    height: 39,
    minWidth: 96,
    paddingHorizontal: 16,
  },
  claimButtonText: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 15,
  },
});
